import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

const NewFastEntryLineItem = ({ onAdd }) => {
  return (
    <Box
      onClick={onAdd}
      sx={{
        width: "100%",
        backgroundColor: "#f5f5f5",
        p: 2,
        py: 1,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#eeeeee"
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        borderTop: "1px dashed rgba(0, 0, 0, 0.12)",
        position: "relative"
      }}
    >
      {/* Center content with icon and text */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1
      }}>
        <AddIcon sx={{ 
          color: "#666666", 
          fontSize: "1.5rem",
          display: 'flex',
          alignItems: 'center',
          marginBottom: '2px'
        }} />
        <Typography
          sx={{
            color: "#666666",
            fontSize: "0.875rem",
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          Add Item
        </Typography>
      </Box>
      
      {/* Keyboard shortcut indicator - positioned absolutely on the right */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
          color: "#888888",
          position: "absolute",
          right: "12px"
        }}
      >
        <Typography
          component="span"
          sx={{
            fontSize: "0.65rem",
            color: "#888888",
            fontWeight: 500
          }}
        >
          Shift+Enter
        </Typography>
        <KeyboardReturnIcon sx={{ fontSize: "0.8rem", color: "#888888" }} />
      </Box>
    </Box>
  );
};

export default NewFastEntryLineItem;